import { useMutation, useQueryCache } from "react-query";
import { ChampionshipAPI } from "api/admin/championship";
import { CHAMPIONSHIPS } from "helpers/constants";
import dispatchToast from "helpers/dispatchToast";

export default function useCreateChampionship() {
  const queryCache = useQueryCache();

  return useMutation(ChampionshipAPI.add, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: "success" });
      queryCache.invalidateQueries(CHAMPIONSHIPS);
      onSuccess();
    },
  });
}
